import React, { useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';
import doctorphoto from "./../../assets/images/sir.png";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

const ContactUs = () => {
  const navigate = useNavigate();
  
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [message, setMessage] = useState("");

  const today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  const year = today.getFullYear();
  const hour = today.getHours();
  if (hour > 17) {
    day = (day + 1);
  }
  let maxmonth = (month + 1);
  if (maxmonth < 10) {
    maxmonth = "0" + maxmonth;
  }
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + (day);
  }

  const minDate = `${year}-${month}-${day}`;

  const maxDate = `${year}-${(maxmonth)}-${day}`;


  /*const [formDataState, setFormDataState] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    //findUs: "",
    //date: minDate,
  });*/
  
	const handleName = (e) =>{

  		setName(e.target.value);
  	}

  	const handleEmail = (e) =>{

  		setEmail(e.target.value);
  	}

  	const handlePhone = (e) =>{
  		console.log(':::' + e);
  		setPhone(e);
  	}

  	const handleMessage = (e) =>{

  		setMessage(e.target.value);
  	}

  const [status, setStatus] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);


  /*const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };*/

	const sendEmail = async (e) => {
    
		e.preventDefault();
	
		setIsSubmit(true);

		// Prepare FormData object
		const formData = new FormData();
		formData.append("name", name);
		formData.append("email", email);
		formData.append("phone", phone);
		formData.append("message", message);


		try 
		{
			const response = await axios.post("https://entdelhi.com/mailer/mailer.php", formData);
			
			if (response.data.success) 
			{
				setStatus("Message sent successfully!");
				// Reset form state
				setName("");
				setEmail("");
				setPhone("");
				setMessage("");
			
				/*setFormDataState({
				  name: "",
				  email: "",
				  phone: "",
				  //findUs: "",
				  message: "",
				});*/

				navigate("/thank-you");
			} 
			else 
			{
				setStatus("Failed to send message.");
				console.error(response.data.error);
			}
			
			setIsSubmit(false);
		} 
		catch (error) 
		{
			setStatus("Something went wrong!");
			console.error("Axios error:", error);
		}
	};

  return (
    <section className="pq-contact-us form-map">
		<div className="container mt-5">
			<div className="row g-4">
				<div className="col-md-6 ">
					<div className="row g-3 stats-row ">
						<div className="col-md-8">
							<h2>Dr. (Major) Rajesh Bhardwaj</h2>
							<h5>MBBS (AFMC), MS, DNB, DLO, DHA</h5>
							<p>Leading ENT Specialist in Delhi NCR</p>
						</div>
						<div className="col-md-4 mob-hide">
							<img src={doctorphoto} style={{ width: '100%' }} className="img-fluid rounded " alt="Hearing Test" />
						</div>
					</div>

					<div className="row g-3 stats-row mb-3">
						<div className="col">
							<i className="fas fa-solid fa-shield"></i>							
							<h6>35 Years+ Experience </h6>
						</div>
						<div className="col">
    <div className="rating-stars">
      <i className="fas fa-solid fa-star"></i>
      <i className="fas fa-solid fa-star"></i>
      <i className="fas fa-solid fa-star"></i>
      <i className="fas fa-solid fa-star"></i>
      <i className="fas fa-solid fa-star"></i>
    </div>
    <h6>Highly Rated</h6>
  </div>
						<div className="col">
							<i className="fas fa-solid fa-microchip"></i>
							<h6>Best Equipped</h6>
						</div>
						<div className="col">
							<i className="fas fa-solid fa-heart"></i>
							<h6>1M+<br/><small>Happy Patients</small></h6>
						</div>
					</div>
				</div>

				<div className="col-md-6">
					<div className="form-section">
						<h4 className="mb-3" style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>Appointment with  Dr. (Major) Rajesh Bhardwaj</h4>
						<form onSubmit={sendEmail}>

							<div className="mb-3">
								<input type="text" className="form-control" placeholder="Patients Name" name="name" required value={name} onChange={handleName} />
							</div>

							<div className="mb-3">
								<input type="email" className="form-control" placeholder="Enter your email" name="email" required value={email} onChange={handleEmail} />
							</div>

							<div className="mb-3">
								{/*<input id="phone" type="tel" className="form-control" placeholder="Your Phone Number" name="phone" required value={formDataState.phone} onChange={handleChange} maxLength="13" onInput={(e) => {
                    				e.target.value = e.target.value.replace(/\D/g, "");
								}} />*/}
								
								<PhoneInput country={'in'} value={phone} onChange={handlePhone} maxLength="13" placeholder="Your Phone Number" name="phone" id="phone" required />
								
							</div>

							<div className="mb-3">
								<textarea id="message" className="form-control" name="message" rows="3" cols="40" placeholder="Describe Your Problems" value={message} onChange={handleMessage}></textarea>

							</div>

							<div className="mb-2">
								<div className="form-check">									
									<input className="form-check-input" type="checkbox" id="policy" required />
									<label className="form-check-label" htmlFor="policy">
          							I agree to the terms in the <a href="#">Privacy Policy</a>
        							</label>
								</div>
								<div className="form-check">
									<input className="form-check-input" type="checkbox" id="offers" />
									<label className="form-check-label" htmlFor="offers">
										I would like MedFirst ENT Centre to send me information about ENT solutions, services and offers.
									</label>
								</div>
							</div>
							{/*<button type="submit" class="btn btn-submit mt-2">Book Appointment Now</button>*/}
							{!isSubmit && <button type="submit" className="btn btn-submit mt-2">Book Appointment Now</button>}
                			{isSubmit && 
								<button type="submit" className="btn btn-submit mt-2" disabled={true}>
									<div className="ms-4 spinner-border text-light" role="status">
										<span className="sr-only">Loading...</span>
									</div>
								</button>
							}
						</form>
					</div>
				</div>
			</div>
		</div>
    </section>
  );
};

export default ContactUs;
